import React, { Component } from "react";
import { Popover, PopoverHeader, PopoverBody } from "reactstrap";
import * as url from "../../utils/url";
import axios from "../../axios";
import NotificationItem from "./NotificationItem/NotificationItem";
import "./Notifications.css";
import "./notifications-bwai.css";
import Spinner from "../../assets/spinner.gif";
import { isMobile, isMobileDevice } from "../../utils/deviceInfo";
import BottomScrollListener from "react-bottom-scroll-listener";
import { isTrivvyProduct, isTrivvyUrl } from "../../utils/constants";

export default class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalNotifications: 0,
      notifications: [],
      unreadNotifications: 0,
      pageNumber: 0,
      notificationOpen: this.props.notificationOpen,
      // axios still more notifications left
      isContinue: true,
      isLoader: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      notificationOpen: nextProps.notificationOpen,
      isLoader: false,
    });
  }

  componentWillMount() {
    if (isMobile || this.props.inPage) this.setState({ isLoader: true });
  }

  componentDidMount() {
    // console.log('compionent')
    this.getNotifications(0);
  }

  loadMore() {
    let { pageNumber, totalNotifications, notifications } = { ...this.state };
    // console.log(totalNotifications, notifications, pageNumber)
    // this.setState({isLoader:true})
    // this.getNotifications(pageNumber + 1);
    if (notifications.length < totalNotifications) {
      this.setState({ isLoader: true });
      pageNumber = pageNumber + 1;
      // console.log(pageNumber)
      this.getNotifications(pageNumber);
    }
  }

  handleScroll = (e) => {
    // const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    let bottom = e.target.scrollHeight - e.target.offsetHeight;
    let { scrollHeight, offsetHeight, scrollTop } = e.target;

    // console.log(e.target, scrollHeight, offsetHeight,scrollTop )

    if (e.target.scrollTop >= bottom) this.loadMore();
  };

  // Get notifications
  getNotifications = (pageNumber) => {
    if (this.state.isContinue) {
      // console.log(pageNumber)
      let payload = {
        pageNumber,
        isMobile: isMobileDevice,
        isTrivvy: isTrivvyProduct(),
      };
      let json_payload = JSON.stringify(payload);
      axios
        .get(`${url.getNotifications}${json_payload}`)
        .then((response) => {
          let {
            total,
            unread,
            docs,
            pageNumber,
            isContinue,
          } = response.data.data;
          if (response.data.data && docs) {
            // console.log(response.data.data)
            let combinedNotifications = [...this.state.notifications, ...docs];
            this.setState({
              notifications: combinedNotifications,
              totalNotifications: total,
              unreadNotifications: unread,
              isContinue: isContinue,
              pageNumber: pageNumber,
            });
            // if(this.state.unreadNotifications!==unread) {
            this.props.onUnreadCountChanged(unread);
            // }
          }
          setTimeout(() => this.setState({ isLoader: false }), 1500);
        })
        .catch((error) => {
          setTimeout(() => this.setState({ isLoader: false }), 1500);
          // console.log(error);
        });
    }
  };

  handleMarkNotificationAsRead = (notification) => {
    this.setState({ isLoader: true });
    if (!notification.readDate) {
      this.markNotificationAsRead(notification._id);
    } else {
      this.setState({ isLoader: false });
      this.props.toggle && this.props.toggle();
    }
  };

  // mark notification as read
  markNotificationAsRead = (notificationId) => {
    axios
      .put(url.markNotificationAsRead + notificationId)
      .then((response) => {
        // console.log('Read Notification Success', response);
        let { readDate } = response.data.data;
        let { notifications, unreadNotifications } = this.state;
        notifications = notifications.map((notification) => {
          if (notification._id === notificationId) {
            return { ...notification, readDate: readDate };
          } else {
            return notification;
          }
        });
        this.setState({
          notifications,
          unreadNotifications: unreadNotifications - 1,
          isLoader: false,
        });
        this.props.onUnreadCountChanged(unreadNotifications - 1);
        this.props.toggle();

        // setTimeout(()=>this.setState({isLoader: false}), 2000);
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  // mark all notifications as read
  markAllNotificationsAsRead = () => {
    axios
      .put(url.markAllNotificationsAsRead)
      .then((response) => {
        let { notifications } = { ...this.state };
        notifications = notifications.map((notification) => {
          return { ...notification, readDate: new Date() };
        });
        this.setState({ notifications, unreadNotifications: 0 });
        this.props.onUnreadCountChanged(0);
        setTimeout(() => this.setState({ isLoader: false }), 1500);
      })
      .catch((error) => {
        setTimeout(() => this.setState({ isLoader: false }), 1500);
        // console.log(error);
      });
  };

  render() {
    let {
      notifications,
      notificationOpen,
      unreadNotifications,
      isLoader,
    } = this.state;

   

    console.log("nnnnnn_____", notifications);
    // inPage: the /home/notifications page always shows the list. A popover there
    // has no bell to anchor to, which crashed the page outside the mobile layout
    // (a tablet rotated past 768px, a window widened, the link opened on a laptop).
    if (isMobile || this.props.inPage) {
      return (
        <div
          className="popover-notifications bwai-notifications"
          placement="bottom-end"
        >
          <div
            className="popover-header-notifications d-flex justify-content-between align-items-center"
            style={{
              ...(isMobile && {
                marginTop: "70px",
              }),
            }}
          >
            <div
              className={`notification-header-title ${isLoader &&
                unreadNotifications == 0 &&
                "hide"}`}
            >
              {unreadNotifications > 0
                ? "You have unread notifications"
                : "You have no unread notifications"}
            </div>
            <div
              className="mark-as-all-read-txt cursor-pointer pr-1"
              onClick={this.markAllNotificationsAsRead}
            >
              {unreadNotifications > 0 ? "Mark All as Read" : ""}
            </div>
          </div>
          {(isMobile || notifications.length > 0) && isLoader ? (
            <div className="spinnerContainer">
              <img src={Spinner} />
            </div>
          ) : null}
          <BottomScrollListener onBottom={this.loadMore.bind(this)}>
            <div
              className={
                isLoader
                  ? "notificationBackgroundLoader"
                  : "popover-body-notifications"
              }
            >
              {notifications.length > 0 &&
                notifications.map((notification, index) => {
                  // console.log(notification)
                  return (
                    <NotificationItem
                      {...this.props}
                      key={index}
                      notification={notification}
                      markAsRead={this.handleMarkNotificationAsRead}
                    />
                  );
                })}
            </div>
          </BottomScrollListener>
        </div>
      );
    }
    return (
      <Popover
        className="popover-notifications bwai-notifications"
        placement="bottom-end"
        isOpen={notificationOpen}
        target="notification-popover"
        toggle={this.props.toggle}
      >
        <PopoverHeader className="popover-header-notifications d-flex justify-content-between align-items-center">
          <div className="notification-header-title">
            {unreadNotifications > 0
              ? "You have unread notifications"
              : "You have no unread notifications"}
          </div>
          <div
            className="mark-as-all-read-txt cursor-pointer"
            onClick={this.markAllNotificationsAsRead}
          >
            {unreadNotifications > 0 ? "Mark All as Read" : ""}
          </div>
        </PopoverHeader>
        <PopoverBody
          className={
            isLoader
              ? "notificationBackgroundLoader"
              : "popover-body-notifications"
          }
          onScroll={this.handleScroll}
        >
          {notifications.length > 0 && isLoader ? (
            <div className="spinnerContainer">
              <img src={Spinner} />
            </div>
          ) : null}
          {notifications.length > 0 &&
            notifications.map((notification, index) => {
              // console.log(notification)
              return (
                <NotificationItem
                  {...this.props}
                  key={index}
                  notification={notification}
                  markAsRead={this.handleMarkNotificationAsRead}
                />
              );
            })}
        </PopoverBody>
      </Popover>
    );
  }
}
